var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 6.33333V3.66667C3.33331 2.95942 3.61426 2.28115 4.11436 1.78105C4.61446 1.28095 5.29274 1 5.99998 1C6.70722 1 7.3855 1.28095 7.8856 1.78105C8.38569 2.28115 8.66665 2.95942 8.66665 3.66667V6.33333M2.66665 6.33333H9.33331C10.0697 6.33333 10.6666 6.93029 10.6666 7.66667V11.6667C10.6666 12.403 10.0697 13 9.33331 13H2.66665C1.93027 13 1.33331 12.403 1.33331 11.6667V7.66667C1.33331 6.93029 1.93027 6.33333 2.66665 6.33333ZM6.66665 9.66667C6.66665 10.0349 6.36817 10.3333 5.99998 10.3333C5.63179 10.3333 5.33331 10.0349 5.33331 9.66667C5.33331 9.29848 5.63179 9 5.99998 9C6.36817 9 6.66665 9.29848 6.66665 9.66667Z",
    stroke: "#D82140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.c4d9ff3d5039b2f5baeec245ecac1a9d.svg";
export { ForwardRef as ReactComponent };